import {settings} from '../config';

function nativeBridgeValue(method) {
    try {
        if (typeof window !== 'undefined' && window.ValzumDevice && typeof window.ValzumDevice[method] === 'function') {
            return window.ValzumDevice[method]();
        }
    } catch (error) {
        return null;
    }

    return null;
}

function browserDeviceUid() {
    try {
        if (typeof window === 'undefined' || !window.localStorage) {
            return null;
        }

        const key = 'valzum_browser_device_uid';
        let value = window.localStorage.getItem(key);

        if (!value) {
            const random = window.crypto && typeof window.crypto.getRandomValues === 'function'
                ? Array.from(window.crypto.getRandomValues(new Uint32Array(4))).map(part => part.toString(16)).join('')
                : String(Date.now()) + String(Math.random()).replace(/\D/g, '');
            value = 'web-' + random;
            window.localStorage.setItem(key, value);
        }

        return value;
    } catch (error) {
        return null;
    }
}

export function devicePayload() {
    const deviceUid = settings.device_uid || nativeBridgeValue('getDeviceUid') || browserDeviceUid();
    const deviceUidSource = settings.device_uid_source || nativeBridgeValue('getDeviceUidSource') || (deviceUid ? 'browser' : null);

    return {
        device: settings.device || null,
        name: settings.name || 'Web',
        version: settings.version || null,
        build: settings.build || null,
        ios_id: settings.ios_id || null,
        device_uid: deviceUid,
        device_uid_source: deviceUidSource,
        fcm_token: settings.fcm_token || null,
        onesignal_user_id: settings.onesignal_user_id || null,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null
    };
}
